import { Box } from '@mui/material'
import React from 'react'
import { useTheme } from '@mui/material/styles'
import homepageLogoADV from '../assets/logo-bancaprogetto.png'
import homepageLogoComplify from '../assets/complify-logo.png'

const logo = process.env.NODE_ENV !== 'production' ? homepageLogoComplify : homepageLogoADV;

function TopLogoDiv() {
    const theme = useTheme();
    return (
        <Box
            sx={{
                height: 'auto',
                width: '10rem',
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'center',
                //padding: '1rem 0', // Aggiunge spazio verticale
            }}
        >
            <Box
                component="img"
                sx={{
                    maxWidth: '100%',
                    height: 'auto',
                    objectFit: 'contain',
                }}
                alt="Logo"
                src={logo}
            />
        </Box>
    );
}

export default TopLogoDiv;
